import { ConfigurationFeatureFlag } from '@tink/config/src/tinkLinkConfig';
import React from 'react';
import { connect } from 'react-redux';
import { useSelectedProvider } from '../../components/App/ProviderContainer/useSelectedProvider';
import {
  Configuration,
  useConfiguration,
} from '../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';

import { User } from '../../models/user';
import { AppState, ConnectedPropsWithoutDispatch } from '../../stores/redux-store';
import { resetCredentials as resetCredentialsConnect } from '../../stores/credentials-store';
import { applicationParameters } from '../../utilities/application-parameters';
import {
  ProductsMachineView as ProductsMachineViewImport,
  ProductsMachineViewProps,
} from '../ProductsMachineView';

export type ProductsDirectorProps = PropsFromRedux & {
  ProductsMachineView?: React.ComponentType<ProductsMachineViewProps>;
};

export const ProductsDirectorPresenter = ({
  user,
  credentials,
  resetCredentials,
  ProductsMachineView = ProductsMachineViewImport,
}: ProductsDirectorProps) => {
  const { selectedProvider } = useSelectedProvider();
  const { data: configurationData } = useConfiguration();
  const refreshableItems = applicationParameters.get('refreshableItems');
  const shouldRedirectEarly = Configuration.hasFeatureFlag(
    configurationData,
    ConfigurationFeatureFlag.SKIP_UPDATING_CREDENTIALS
  );

  return (
    <ProductsMachineView
      isPermanentUser={!User.isTemporary(user)}
      credentialsId={credentials?.id}
      provider={selectedProvider}
      refreshableItems={refreshableItems}
      shouldRedirectEarly={shouldRedirectEarly}
      onCancel={resetCredentials}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    user: state.user.user,
    credentials: state.credentials.data,
  };
};

const connector = connect(mapStateToProps, {
  resetCredentials: resetCredentialsConnect,
});

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const ProductsDirector = connector(ProductsDirectorPresenter);
